export const queryKeys = {
  BOSS_MONTHLY_PAYMENT: 'BOSS_MONTHLY_PAYMENT',
  HOUSES: 'HOUSES'
};
